// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2Br7Q","info":"UpdateTermsInfo_info__1AZjP"};